import s from './Full.module.scss';

const FullSlide = ({ image }: { image: string }) => {
  return (
    <div className={s.root}>
      <img src={image} className={s.image} alt="office" />
    </div>
  );
};

export { FullSlide };
